export default "__VITE_ASSET__4060490b__"